const faqTypes = [
    {
        "id": 1,
        "description": "Opción",
    },
    {
        "id": 2,
        "description": "Respuesta",
    },
    {
        "id": 3,
        "description": "Solución",
    },
    {
        "id": 4,
        "description": "Pregunta",
    },
    {
        "id": 5,
        "description": "Servicio",
    },
]

export { faqTypes }